import * as React from "react";
import { SubscriptionDeliveryIntervalSelect } from "@grandvisionhq/lib-visuals";
import { useDeliveryIntervalOptions } from "./use-delivery-interval-options.js";
import { pushDeliveryIntervalSelectionEvent } from "../../../../../../../Analytics/events/modules/Analytics/events/subscription-events.js";
import { useProductData } from "../../../../../../../../context/context/product-context-hooks.js";
import { isSubscriptionPurchase } from "../../../../../../../../types/types/typeguards.js";
const DeliveryIntervalSelectContainer = ({
  className,
  hasError,
  deliveryInterval,
  onIntervalSelection
}) => {
  const { selectedPurchaseType, activeVariant } = useProductData();
  let availableSubscriptionIntervals;
  if ("availableSubscriptionIntervals" in activeVariant) {
    availableSubscriptionIntervals = activeVariant.availableSubscriptionIntervals;
  }
  const { deliveryIntervalOptions, selectedInterval, singleDeliveryIntervalOption } = useDeliveryIntervalOptions({
    deliveryInterval,
    availableSubscriptionIntervals
  });
  const handleIntervalSelection = React.useCallback(
    (interval) => {
      pushDeliveryIntervalSelectionEvent(interval);
      onIntervalSelection(interval);
    },
    [onIntervalSelection]
  );
  if (!isSubscriptionPurchase(selectedPurchaseType)) {
    return null;
  }
  if (!deliveryIntervalOptions) {
    console.error(
      `No delivery interval options or fallback options have been set for sku: '${activeVariant.sku}'`
    );
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    SubscriptionDeliveryIntervalSelect,
    {
      className,
      hasError,
      selectedInterval,
      singleOptionLabel: singleDeliveryIntervalOption?.label,
      deliveryIntervalOptions,
      onIntervalSelection: handleIntervalSelection
    }
  );
};
export {
  DeliveryIntervalSelectContainer
};
//# sourceMappingURL=DeliveryIntervalSelectContainer.js.map
